import BylvayIsi from './important_safety_information/bylvay';
import XcopriIsi from './important_safety_information/xcopri';

/**
 * Sticky ISI footers that builder-defined questions can enable, keyed by the
 * isi_key values allowed on QuestionnaireQuestion.
 */
export const ISI_OPTIONS = [
  { key: 'bylvay', label: 'BYLVAY', Component: BylvayIsi },
  { key: 'xcopri', label: 'XCOPRI', Component: XcopriIsi },
];

export const isiComponentForKey = (key) => {
  const option = ISI_OPTIONS.find((entry) => entry.key === key);
  return option ? option.Component : null;
};
